import _ from "lodash"
import { setValue, getGridSpanStyles } from "./";
import { styles } from '../constants'

export const getDefaultValues = (pluginType: string, deviceType: string, parentId: string) => {
  const a8Window: any = window;
  const plugin = a8Window[pluginType];

  const defaultValues: any = {
    properties: {
      styles,
      config: {
        visible: true,
      }
    }
  };

  const mergedDefaults = _.merge(
    {},
    defaultValues,
    getGridSpanStyles(parentId),
    plugin?.data?.json || {}
  );

  if (plugin?.data) {
    const { config = {} } = plugin.data;
    Object.keys(config).forEach((key) => {
      const field = config[key];
      let path = (field.key || field.section) + "." + key;
      path = path.replace(/\$deviceType/g, deviceType)
      setValue(mergedDefaults, path.split("."), field.default, deviceType);
    });
  }

  return mergedDefaults;
};
